import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import * as GlobalAccountViews from 'global-account/views'
import * as Views from './views'
import Layout from './Layout'
import { PATH, makePath } from 'config'

const propTypes = {}

function Routes() {
  const { path } = useRouteMatch()

  return (
    <Layout>
      <Switch>
        <Route exact path={makePath(path, PATH.ROOT)}>
          <Views.Account />
        </Route>
        <Route path={makePath(path, PATH.NEW)}>
          <GlobalAccountViews.NewContact />
        </Route>
      </Switch>
    </Layout>
  )
}

Routes.propTypes = propTypes

export default Routes
